import React from 'react';
import { AccountFormProvider, AccountPageProvider } from '../context';
import FormDialog from './FormDialog';

interface FormDialogWrapperProps {
  open: boolean;
  mode: 'add' | 'edit' | 'view';
  formMode?: 'add' | 'edit' | 'view';
  initialData?: any;
  onClose: () => void;
  onSubmit?: (data: any) => void;
  onSaved?: (data: any) => void;
  zIndex?: number;
}

export default function FormDialogWrapper({
  open,
  mode,
  formMode,
  initialData,
  onClose,
  onSubmit,
  onSaved,
  zIndex
}: FormDialogWrapperProps) {
  if (!open) return null;

  const resolvedMode = mode || formMode || 'add';

  return (
    <AccountPageProvider>
      <AccountFormProvider
        account={resolvedMode === 'edit' ? initialData || null : null}
        mode={resolvedMode}
        isCopyMode={false}
        onClose={onClose}
        onSuccess={async savedAccount => {
          if (savedAccount) {
            if (onSaved) {
              onSaved(savedAccount);
            } else {
              onSubmit?.(savedAccount);
            }
            return;
          }
          onClose();
        }}
      >
        <FormDialog zIndex={zIndex} />
      </AccountFormProvider>
    </AccountPageProvider>
  );
}
